module.exports = __webpack_public_path__ + "img/4.9dbd4fd0.png";